import React from 'react'
import {   Field} from 'redux-form'

const svinputRenderField = ({input, label, type, meta:{error, touched}})=>{
    return(

     
            <input {...input}  component="input" type="input"   className="form-control" />
           

    
       
    )

}


export class SVNArray extends React.Component{
    

    constructor(props){
        super(props)


    }
  
    componentWillReceiveProps(next){
        console.log('props changed SVNArray')

    }
   

    render(){
        console.log('render SVNArray')
        console.log(this.props)

        let me = this

        let {member,index, placeholder ='21,22'} = this.props
/*
        const {label,label_forName, input, type,
            meta:{
              touched, error, warning
            }
           } = this.props*/
          return (
           <Field 
            className="form-control" 
            
            
             type="text" placeholder={placeholder}
             component={svinputRenderField}
             name={`${member}.portInput`}
             id={`${member}.portInput`}
              placeholder={placeholder} >
        
          </Field> )
           {/*  return (<div className="form-group">
                <label  forName={label_forName}>{label}
                </label>
                <input   onBlur={() => console.log('sv') }  {...input} type={type} id={portEntryId} className="form-control" placeholder="SVparalleltask"  />
                { touched && ((error && <span>{error}</span> )) || (warning && <span>{warning}</span>) }
            
            </div>
      
             )  
            */}
       

    }
}